import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/str")({
  beforeLoad: () => {
    throw redirect({
      to: "/operator/str/listings",
      search: {
        view: "list",
        page: 1,
        pageSize: 50,
        sort: "platform",
        direction: "asc",
        filters: "",
      },
    });
  },
});
